import {toRange,rangeObj,range as getRange} from "../helpers/column_names";
import * as tbl from "../table";
import group from "../operations/undo_group";
import {newSheet, prepareCell, getSheet} from "../sheets";
import {getType, loadCell, handleChange} from "../operations/types";
import {getExcelDateFromJs} from "../mathematics/methods";
import {checkFormat, getFormatFromData} from "../operations/formats";
import * as arr from "../helpers/array";
import {fillEditor} from "../editor";
import {isInvalid} from "../operations/validation";

export function refresh(all){
	if (all)
		this._table.refreshColumns();
	else
		this._table.refresh();
}
export function eachSelectedCell(cb){
	var cells = this.getSelectedId(true);
	for (var i=0; i<cells.length; i++)
		cb.call(this, cells[i]);
}
export function getSelectedRange(sheet){
	var area = this._table.getSelectArea();
	if (area){
		if (sheet)
			sheet = this.getActiveSheet();
		return toRange(area.start.row,area.start.column,area.end.row,area.end.column,sheet);
	}
	return "";
}
export function getSelectedId(all){
	var area = this._table.getSelectArea();
	if(!all)
		return area && area.start.row ? area.start : null;

	var selection = [];
	if(area){
		var c0 = area.start;
		var c1 = area.end;

		for(var i = c0.row; i<= c1.row; i++){
			for(var j = c0.column; j <= c1.column; j++){
				selection.push({row: i,column:j});
			}
		}
	}

	return selection;
	//return this._table.getSelectedId(all)
}
export function getCellValue(row, column, math, page){
	page = page ? this._mData.getPage(page) : this._mPage;

	if(!page)
		return;

	const value = page.getValue(row-1, column-1, math !== false);

	return correctVal(value);
}
export function setCellValue(row, column, value, page){
	if(!page)
		page = this.getActiveSheet();

	const muonPage = this._mData.getPage(page);
	if(!muonPage)
		return;

	value = correctVal(value);
	const old = this.getCellValue(row, column, true, page);
	const oldType = getType(this, row, column, page);
	let oldStyle, oldEditor;

	if(!this._type_change && page != this.getActiveSheet()){
		oldStyle = this.getStyle(row, column, page);
		oldEditor = this.getCellEditor(row, column, page);
	}

	let sameValue;
	if(oldType == "date"){
		const parser = webix.Date.strToDate( webix.i18n.spreadsheet.formats.parseDateTime );
		let dateValue;
		if(isNaN(value)){
			const jsDate = parser(value);
			if(jsDate === "")
				dateValue = value;
			else
				dateValue = getExcelDateFromJs(jsDate);
		}
		else
			dateValue = value;
		sameValue = old == dateValue;
	}
	else if(oldType != "string" && value !== "" && !isNaN(value) && old == value && value !== 0){
		sameValue = true;
		value = value*1;
	}

	if (!sameValue && old !== value){
		group.set(()=>{
			if (this.callEvent("onBeforeValueChange",[row, column, value, old, page])){
				if(page != this.getActiveSheet()){
					const sheet = getSheet(this, page).content;
					let cell = arr.find(sheet.data, cell => cell[0] == row && cell[1] == column);

					if(!cell){
						cell = [row, column];
						sheet.data.push(cell);
					}
					cell[2] = value;

					this._page_value_set = true;
					cell[4] = null;
					const item = loadCell(this, sheet, cell);
					delete this._page_value_set;

					const muonItem = muonPage.getCell(row-1, column-1, true);
					muonItem.$format = checkFormat(this, { fmt: getFormatFromData(this, sheet, cell) }, "string") ? 1 : 0;
					muonPage.setValue(row-1, column-1, item.value);

					cell[2] = item.value;
					cell[4] = muonItem.type = item.type;

					this._type_change = true;
					//prepareCell can change style (1/1/2001 --loadCell--> 36892 + date type --prepareCell--> date format)
					prepareCell(cell, sheet, true);
					muonItem.style = cell[3];
					delete this._type_change;

					if(!this._validation_restore && !this._type_change && isInvalid(this, row, column, null, page)){
						const validation = this.validation.get(row, column, page);
						const oldData = { value: old, style: oldStyle, editor: oldEditor };

						showValidationError(this, validation)
							.then(()=>{
								if(validation.errorHandle == "stop")
									restoreValue(this, row, column, oldData, page);
								else
									this.callEvent("onCellChange", [row, column, value, page]);
							})
							.fail(()=>{
								restoreValue(this, row, column, oldData, page);
							});
					}
					else
						this.callEvent("onCellChange", [row, column, value, page]);
				}
				else {
					const sel = this.getSelectedId();
					fillEditor(this, sel, true);

					this._mPage.setValue(row-1, column-1, value);

					if(!this._type_change){
						this._type_change = true;
						handleChange(this, row, column, value);
						delete this._type_change;
					}

					const updatedType = getType(this, row, column);

					//recalculate if we refer to a cell, where type is string and value is something like 005 or 5e5
					if(oldType != updatedType && updatedType == "string" && value[0] == "=" && value.length > 1)
						this._mPage.setValue(row-1, column-1, value);

					fillEditor(this, sel);

					if(/^=hyperlink\(/i.test(value)){
						const baseStyle = this.getStyle(row, column);
						const urlStyle = this.addStyle({ color: "#0000ff", underline: "underline" }, baseStyle);
						this.setStyle(row, column, urlStyle);
					}

					if(!this._validation_restore && !this._type_change && isInvalid(this, row, column, tbl.getRenderedValue(this, row, column))){
						const validation = this.validation.get(row, column);
						showValidationError(this, validation)
							.then(()=>{
								if(validation.errorHandle == "stop")
									restoreValue(this);
								else
									this.callEvent("onCellChange", [row, column, value, page]);
							})
							.fail(()=>{
								restoreValue(this);
							});
					}
					else if(!this._type_change)
						this.callEvent("onCellChange", [row, column, value, page]);
				}

				if(!this._type_change)
					this.saveCell(row, column, page);
			}
		});
	}
}

function restoreValue(view, row, column, data, page){
	view._validation_restore = true;
	if(page){
		view.setStyle(row, column, data.style, page);
		view.setCellEditor(row, column, data.editor, page);
		view.setCellValue(row, column, data.value, page);
	}
	else{
		view.undo();
		view._ssUndoHistory.splice(view._ssUndoCursor+1);
	}
	delete view._validation_restore;
}

function showValidationError(view, validation){
	const errorHandle = validation.errorHandle || "information";

	const type = errorHandle == "stop" ? "alert-error" : (errorHandle == "warning" ? "confirm-" : "alert-") + errorHandle;
	const locale = webix.i18n.spreadsheet.labels;
	return view[errorHandle == "warning" ? "confirm" : "alert"]({
		type,
		ok: locale["validation-error-" + (errorHandle == "stop" ? "restore" : "save")],
		cancel: locale["validation-error-restore"],
		title: validation.errorTitle || locale["validation-error-title-text"],
		text: validation.errorMessage || locale["validation-error-message-text"]
	});
}

function correctVal(val){
	if(typeof val === "boolean")
		val *= 1;
	return val || val === 0 ? val : "";
}

export function setRangeValue(range, value, page){
	group.set(function(){
		const pos = rangeObj(range, this);
		let i = 0;
		for (let row = pos.start.row; row <= pos.end.row; row++) {
			for (let column = pos.start.column; column <=  pos.end.column; column++, i++) {
				this.setCellValue(row, column, webix.isArray(value) ? value[i] : value, page);
			}
		}
	},this);
}

export function getRangeValue(range, page){
	if(!page)
		page = this.getActiveSheet();

	const pos = getRange(range, this, page);
	const muonPage = this._mData.getPage(pos[4]);

	if (!pos || !muonPage) return [];

	return muonPage.getRange(pos[0]-1, pos[1]-1, pos[2]-1, pos[3]-1).map(correctVal);
}

export function getRow(id, page){
	let row, colCount;

	const isActiveSheet = !page || page == this.getActiveSheet();
	if(isActiveSheet){
		row = webix.copy(this._table.getItem(id));
		colCount = this.config.columnCount;
	}
	else{
		const sheet = getSheet(this, page);
		if(sheet){
			let height;
			if(sheet.content.sizes)
				height = arr.find(sheet.content.sizes, size => size[0] == id);
			height = height ? height[2] : this.$$("cells").config.rowHeight;
			row = {id, $height: height};
			colCount = arr.getDimension(sheet.content.data, sheet.content.spans, 1, 1, sheet.content.filters)[1];
		}
		else return;
	}

	for(let i = 1; i <= colCount; i++){
		const cell = (isActiveSheet ? this._mPage : this._mData.getPage(page)).getCell(id-1, i-1);

		if(cell){
			row[i] = cell.value;

			[["style", "$cellCss"], ["type", "$cellType"], ["format", "$cellFormat"]].forEach(param => {
				const val = cell[param[0]];
				if(val){
					if(!row[param[1]])
						row[param[1]] = {};
					row[param[1]][i] = val;
				}
			});

			const math =  this.getCellValue(id, i, true, page);
			if(math && math[0] == "=")
				row["$"+i] = math;
		}
	}

	return row;
}
export function getColumn(id, page){
	if(!page || page == this.getActiveSheet())
		return this._table.getColumnConfig(id);

	const sheet = getSheet(this, page);
	if(sheet){
		let width;
		if(sheet.content.sizes)
			width = arr.find(sheet.content.sizes, size => size[1] == id);
		width = width ? width[2] : this.$$("cells").config.columnWidth;
		return {id, width};
	}
}
export function reset(mode){
	var obj = { data:[] };
	if (mode && mode.sheets){
		obj = newSheet(obj);
	}
	
	this.parse(obj);
}

export function _resetTable(){
	tbl.reset(this);
}

export function refToPos(text){
	return getRange(text);
}

export function posToRef(r1, c1, r2, c2, page){
	return toRange(r1, c1, r2, c2, page);
}